import React from "react";
import { Box } from "../elements/Box";
import { Flex } from "../elements/Flex";

const ClippedPathContainer = ({ bg, pt = 4, pb, py, px, children, clippedBg }) => {
  return (
    <Flex bg={bg} width="100%" position="relative" pt={pt} pb={pb} py={py} px={px}>
      {children}

      <Box
        position="absolute"
        zIndex={100}
        bg={clippedBg || "white"}
        height="40px"
        width="100%"
        bottom="-1px"
        style={{ clipPath: "polygon(0 0, 100% 50%, 100% 100%, 0% 100%)" }}
      />
    </Flex>
  );
};

export default ClippedPathContainer;
